// eslint-disable-next-line import/prefer-default-export
export const randomString = () => Math.random().toString(36).slice(-10);
